import React, { useMemo } from 'react'

import Context from './context'

export default ({ children, value }: any) => {
    const memoValue = useMemo(() => {
        return {
            ...(value || {})
        }
    }, [value])

    return <Context.Provider value={memoValue}>{children}</Context.Provider>
}
